import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App.jsx'; 
import createApp from '@shopify/app-bridge'; 

const config = window.appBridgeConfig; 

window.app = createApp(config); 
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import '@shopify/polaris/build/esm/styles.css';

ReactDOM.render(<App config={config} />, document.getElementById('app'));